import qs from 'qs'
import { axios } from './axios'
import { ExportType } from '@archax/shared-types'

export type GetExportsBaseParams = {
  type?: string
  status?: string
  sort?: {
    field: string
    direction: 'asc' | 'desc'
  } | null
}

export const getAllExports = (params: GetExportsBaseParams) => {
  const { sort, ...rest } = params
  const queryObj = { ...rest, ...(sort && { sort: `${sort.field},${sort.direction}` }) }
  const querystring = qs.stringify(queryObj, { indices: false })
  return axios.get(`/exports?${querystring}`)
}

export const getExportById = (exportId: string) => {
  return axios.get(`/exports/${exportId}`)
}

export const createExport = async (type: ExportType, data: Record<string, unknown>) => {
  return axios.post(`/exports`, {
    type,
    data,
  })
}

export const downloadExportFile = async (id: string, fileName: string) => {
  const response = await axios.get(`/exports/${id}/download`, {
    responseType: 'blob',
  })
  const url = URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
